
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.assignment_sync_settings";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/AssignmentSyncSettings';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"form-dialog-content sync-to-sis-message-content\">\n  <span class=\"disable-sync-to-sis-message\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'sisName': ((depth0 && depth0.sisName)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "are_you_sure_you_want_to_disable_sync_to_sisname_f_f24245c1", "Are you sure you want to disable Sync to %{sisName} for all assignments?", options) : helperMissing.call(depth0, "t", "are_you_sure_you_want_to_disable_sync_to_sisname_f_f24245c1", "Are you sure you want to disable Sync to %{sisName} for all assignments?", options)))
    + "\n  </span>\n</div>\n\n<div class=\"form-controls\">\n  <button\n    id=\"cancel-assignment-settings\"\n    class=\"btn dialog_closer\"\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</button>\n  <button\n    id=\"update-assignment-settings\"\n    class=\"btn btn-primary\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "disabling_f594bda", "Disabling...", options) : helperMissing.call(depth0, "t", "disabling_f594bda", "Disabling...", options)))
    + "'\n    type=\"submit\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "disable_a5c05db3", "Disable", options) : helperMissing.call(depth0, "t", "disable_a5c05db3", "Disable", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  